import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { YatLogo } from '@pkg/assets/brand';

import { IconWrapper, Skeleton, SkeletonWrapper, StyledLoader } from './Loader.style';

export interface LoaderProps {
    failed?: boolean;
}

export function Loader({ failed = false }: LoaderProps) {
    const skeletonMarkup = failed ? null : (
        <SkeletonWrapper key="VisualAsset-Loader-Skeleton">
            <Skeleton />
        </SkeletonWrapper>
    );

    return (
        <StyledLoader $failed={failed}>
            <AnimatePresence>{skeletonMarkup}</AnimatePresence>

            <IconWrapper>
                <YatLogo />
            </IconWrapper>
        </StyledLoader>
    );
}
